import React from 'react'
import ImageWithFallback from 'app/components/ImageWithFallback'
import Assets from 'app/configs/assetConfigs'
import LanguageIcon from '@material-ui/icons/Language'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import StayCurrentPortraitIcon from '@material-ui/icons/StayCurrentPortrait'
import CakeOutlinedIcon from '@material-ui/icons/CakeOutlined'
import { compose, find, propEq, prop, isNil } from 'ramda'
import moment from 'moment'
import { DISPLAY_FORMAT_DATE } from 'libs/dateUtils'

export default ({ accountData, languages }) => {
  const languageName = compose(
    prop('name'),
    find(propEq('id', accountData.languageId)),
  )(languages)

  return (
    <div className="w-full rounded-4 border border-primary-350 p-5 py-10 text-16 text-neutrals-500 space-y-5">
      <div className="flex items-center space-x-5">
        <div className="flex w-24 h-24">
          <ImageWithFallback
            src={accountData.profilePicture}
            fallbackSrc={Assets.personSilhouetteImage}
            className="rounded-full w-full"
          />
        </div>
        <div className="w-full px-2">{`${accountData.firstName} ${accountData.lastName}`}</div>
      </div>
      <div className="flex items-center space-x-5">
        <div className="flex w-24">
          <LanguageIcon />
        </div>
        <div className="w-full px-2">{languageName}</div>
      </div>
      {!isNil(accountData.email) && (
        <div className="flex items-center space-x-5">
          <div className="flex w-24">
            <MailOutlineIcon />
          </div>
          <div className="w-full px-2">{accountData.email}</div>
        </div>
      )}
      {!isNil(accountData.phoneNumber) && (
        <div className="flex items-center space-x-5">
          <div className="flex w-24">
            <StayCurrentPortraitIcon />
          </div>
          <div className="w-full px-2">{`${accountData.countryCode} ${accountData.phoneNumber}`}</div>
        </div>
      )}
      {!isNil(accountData.birthday) && (
        <div className="flex items-center space-x-5">
          <div className="flex w-24">
            <CakeOutlinedIcon />
          </div>
          <div className="w-full px-2">
            {moment(accountData.birthday).format(DISPLAY_FORMAT_DATE)}
          </div>
        </div>
      )}
    </div>
  )
}
